import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import useOnclickOutside from "react-cool-onclickoutside"
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL } from '../../../services/redirect'
import Spinner from '../../../services/spinner'
import AlertMessage from '../../../services/alert'

import { DropdownComponent } from '../../../components/options'
import { ValidateForm } from '../../../validations/schemaPages'


export default function AddComponent(props){

  /*----------------------------------------
    HANDLE CLICK OUTSIDE ELEMENT
  -----------------------------------------*/

  const handleClickAway = useOnclickOutside(() => CallbackModal({close:true}));
  function CallbackModal(data){
    if(spinner){
      return false;
    }
    props.callback(data);
  }


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }


  /*----------------------------------------
    FORM STATE DATA
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  const [pathUrl, setPathUrl] = useState('');

  const [avatarDefault, setPathUrlDefault] = useState('');
  const [avatarBlank, setPathUrlBlank] = useState('');

  const [state, setstate] = useState({
    name:'',
    description:''
  });



  function handleSubmitForm(values, props){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','add');
    formData.append('info',JSON.stringify(values));
    axios.post('/admin/system-administration/pages/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);


      if(obj=='success'){
        props.resetForm();
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},2000);
        if(buttonclick==1){
          setTimeout(function() {CallbackModal({close:true,reload:true});},2000);
        }else{
          setTimeout(function() {
            setTimeout(function() {setnotify(false);},2000);
            CallbackModal({reload:true});
          },2000);
        }
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

    })
    .catch(function (error){
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }


  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [yesnoOptions, setYesNoOptions] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setYesNoOptions(source.yesnostatus);
  }


  useEffect(()=>{
      HandleOptions();
  },[]);


  return (
    <React.Fragment>

    <Formik
        initialValues={state}
        validationSchema={ValidateForm}
        onSubmit={handleSubmitForm}
        render={formProps => {
        const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue } = formProps

        return(
           <Form>
            <div className="modalpanel-wrapper">
              <div className="modalpanel-container small center animate__animated animate__slideInUp animate__faster" ref={handleClickAway}>

              {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
              {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}


              {/*---------------------------------------------------------
                 HEADER
                --------------------------------------------------------*/}
                 <div className="modalpanel-header">
                    <div><h2>Add Page</h2></div>
                    <div onClick={()=>CallbackModal({close:true})}><i className="uil-multiply"></i></div>
                 </div>


                 {/*---------------------------------------------------------
                    BODY
                   --------------------------------------------------------*/}

                 <div className="modalpanel-body">
                    <div className="modalpanel-content">

                        <Form.Group widths="equal">
                            <Field name="name">
                                {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Name</label>
                                  <Input {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Field name="description">
                                {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Description</label>
                                  <TextArea {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                        </Form.Group>

                    </div>
                 </div>


                 {/*---------------------------------------------------------
                    FOOTER
                   --------------------------------------------------------*/}

                 <div className="modalpanel-footer">
                    <div className="modalpanel-footer-container">
                       <div><Button disabled={!(isValid&&dirty)} fluid className='LightGrayButton strong' content='Save and Exit' icon='save icon' onClick={() => buttonSubmit(1)}/></div>
                       <div><Button disabled={!(isValid&&dirty)} fluid className='PrimaryButton strong' content='Save and Stay' icon='save icon' onClick={() => buttonSubmit(2)}/></div>
                     </div>
                     <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                 </div>



              </div>{/*.modalpanel-container*/}
            </div>
          </Form>
        )}}/>
    </React.Fragment>
  )
}
